import {
  INTERNAL_GIS_LAYERS,
  type InternalGisLayer,
} from './internal_gis_layers';

/**
 * Catalog of GIS layers available to the `// add` action. Sourced
 * from JSON under `internal_gis_layers/`, so catalog updates are
 * data-only changes once the barrel import is in place.
 *
 * Shape is intentionally minimal: `name` drives the palette row
 * label and the canonical command text, `url` is the underlying
 * service endpoint a future activation tier will load, and optional
 * `category` can be shown as a sublabel when present.
 */
export type ExternalGisLayer = InternalGisLayer;

export const EXTERNAL_GIS_LAYERS: readonly ExternalGisLayer[] =
  INTERNAL_GIS_LAYERS;
